import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/fmt";
import { toast } from "sonner";

export const SettledThroughControl = ({ value, onSaved }) => {
  const [date, setDate] = useState(value || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (value) setDate(value); }, [value]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings/settled-through", { date });
      toast.success(`Settled through ${fmtDate(date)}`);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't save the date");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-hh-border bg-white px-5 py-4 flex items-center gap-4 flex-wrap" data-testid="settled-through-control">
      <div className="flex-1 min-w-[260px]">
        <p className="hh-overline">Settled through</p>
        <p className="text-sm text-hh-ink/70 mt-1">
          All quarters ending on or before this date are treated as paid in full. Move it forward after each payment round.
        </p>
      </div>
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
             className="border border-hh-border rounded-lg px-3 py-2 text-sm" data-testid="settled-through-input" />
      <button className="hh-btn-primary" onClick={save} disabled={saving || !date || date === value} data-testid="settled-through-save">
        {saving ? "Saving…" : "Save"}
      </button>
    </div>
  );
};
